import { delay } from '../delay';
import assign from 'object-assign';
import { DateTime } from 'luxon';
import _ from 'lodash';

export class CalendarApi {

    static date = new Date();
    static currentYear = CalendarApi.date.getFullYear();
    static currentMonth = (CalendarApi.date.getMonth() + 1 < 10) ? '0' + (CalendarApi.date.getMonth() + 1) : (CalendarApi.date.getMonth() + 1);
    static calendarItems = [
        {
            id: 1,
            allDay: true,
            title: 'Trip to London', // All Day event item template
            start: DateTime.utc().set({ year: CalendarApi.currentYear, month: CalendarApi.currentMonth, day: 1, hour: 0, minute: 0, second: 0, millisecond: 0 }).toISO(),
            end: DateTime.utc().set({ year: CalendarApi.currentYear, month: CalendarApi.currentMonth, day: 5, hour: 0, minute: 0, second: 0, millisecond: 0 }).toISO(),
            color: '#00acac',
            extendedProps: { eventType: "standard" }
        },
        {
            id: 2,
            allDay: false,
            title: 'Meet with Irene Wong', // Time specific event template
            start: DateTime.utc().set({ year: CalendarApi.currentYear, month: CalendarApi.currentMonth, day: 2, hour: 6, minute: 0, second: 0, millisecond: 0 }).toISO(),
            color: '#348fe2',
            extendedProps: { eventType: "standard" }
        }
    ];

    fixStartAndEndOnAllDayEvents = (items) => {

        let result = items.map(ci => {
            if (ci.allDay) {
                ci.end = this.setDateToLastSecondOfDay(ci.end ?? ci.start);
                ci.start = this.setDateToBeginningOfDay(ci.start);
            }
            return ci;
        });

        return result;
    }

    setDateToLastSecondOfDay = (date) => {

        let workingDate = typeof date === 'string' ? DateTime.fromISO(date, { zone: 'utc' }) : date;
        let result = DateTime.utc().set({ year: workingDate.c.year, month: workingDate.c.month, day: workingDate.c.day, hour: 23, minute: 59, second: 59, millisecond:999 }).toISO();

        return result;
    }

    setDateToBeginningOfDay = (date) => {

        let workingDate = typeof date === 'string' ? DateTime.fromISO(date, { zone: 'utc' }) : date;
        let result = DateTime.utc().set({ year: workingDate.c.year, month: workingDate.c.month, day: workingDate.c.day, hour: 0, minute: 0, second: 0, millisecond:0 }).toISO();

        return result;
    }

    getEvents = (from, to) => { // eslint-disable-line no-unused-vars

        return new Promise((resolve, reject) => { // eslint-disable-line no-unused-vars
            setTimeout(() => {

                console.log("getting all calendar events");

                let items = this.fixStartAndEndOnAllDayEvents(CalendarApi.calendarItems);
                CalendarApi.calendarItems = items;

                resolve(assign([], items));

            }, delay.value());
        });

    };

    getEventById = (id) => {

        return new Promise((resolve, reject) => { // eslint-disable-line no-unused-vars
            setTimeout(() => {

                console.log("getting single calendar event");

                let items = this.fixStartAndEndOnAllDayEvents(CalendarApi.calendarItems);
                CalendarApi.calendarItems = items;

                resolve(assign({}, _.first(_.filter(items, ci => ci.id === parseInt(id)))));

            }, delay.value());
        });

    };

    deleteEvent = (event) => {
        return new Promise((resolve, reject) => { // eslint-disable-line no-unused-vars
            setTimeout(() => {
                CalendarApi.calendarItems = _.filter(CalendarApi.calendarItems, ci => ci.id !== parseInt(event.id));
                resolve(assign({}, event));

            }, delay.value());
        });
    };

    upsertEvent = (event) => {


        return new Promise((resolve, reject) => { // eslint-disable-line no-unused-vars
            setTimeout(() => {

                let id = event.id ?? CalendarApi.calendarItems.length + 1;

                let existingEvent = _.first(_.filter(CalendarApi.calendarItems, ci => ci.id === parseInt(id)));

                let newEvent = {};

                if (existingEvent) {
                    if (event.start['_isAMomentObject']) {
                        event.start = DateTime.fromISO(event.start.toISOString()).toISO();
                    }
                    if (event.end['_isAMomentObject']) {
                        event.end = DateTime.fromISO(event.end.toISOString()).toISO();
                    }
                    CalendarApi.calendarItems = CalendarApi.calendarItems.map(ci => ci.id !== existingEvent.id ? ci : event);
                }
                else {

                    if (event.start instanceof Date) {
                        newEvent = { id: id, title: event.title, start: DateTime.fromISO(event.start.toISOString()).toISO(), end: DateTime.fromISO(event.end.toISOString()).toISO(), extendedProps: event.extendedProps };
                    }
                    else {
                        newEvent = { id: id, title: event.title, start: DateTime.fromISO(new Date(event.start).toISOString()).toISO(), end: DateTime.fromISO(new Date(event.end).toISOString()).toISO(), extendedProps: event.extendedProps };
                    }

                    CalendarApi.calendarItems = [].concat(CalendarApi.calendarItems, newEvent)
                }

                let items = this.fixStartAndEndOnAllDayEvents(CalendarApi.calendarItems);
                CalendarApi.calendarItems = items;

                existingEvent = _.first(_.filter(items, ci => ci.id === parseInt(id)));

                resolve(assign({}, existingEvent));
            }, delay.value());
        });
    };

}